"use client"

// src/components/slide-fade.ts
var SlideFade = {
  baseStyle: {
    w: "100%"
  },
  defaultProps: {
    offsetX: 0,
    offsetY: 8,
    reverse: true
  }
};

export {
  SlideFade
};
//# sourceMappingURL=chunk-55CGOROR.mjs.map